import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';
import logoImage from '../assets/logo.png';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { login, loading } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    await login(data.email, data.password);
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden px-4 py-12">
      {/* Background */}
      <div className="absolute inset-0 bg-[#141414]" />
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            'radial-gradient(ellipse 70% 50% at 70% 20%, rgba(92,107,58,0.35), transparent), radial-gradient(ellipse 50% 40% at 10% 90%, rgba(232,197,71,0.08), transparent)'
        }}
      />
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 30c10-8 20-8 30 0s20 8 30 0' fill='none' stroke='%232a2a2a' stroke-width='1'/%3E%3Cpath d='M0 45c10-8 20-8 30 0s20 8 30 0' fill='none' stroke='%23222222' stroke-width='1'/%3E%3C/svg%3E\")"
        }}
      />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto h-20 w-20 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-5 shadow-soft">
            <img 
              src={logoImage} 
              alt="Omega Operations" 
              className="h-14 w-14 object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-white tracking-tight">
            Omega Operations
          </h1>
          <p className="mt-1.5 text-sm text-white/50">
            Zaloguj się, aby kontynuować
          </p>
        </div>

        <form
          className="bg-white rounded-2xl shadow-card-hover border border-black/[0.04] p-6 sm:p-8 space-y-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div>
            <label htmlFor="email" className="block text-sm font-semibold text-ink mb-1.5">
              Adres email
            </label>
            <input
              {...register('email', {
                required: 'Email jest wymagany',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Nieprawidłowy format email'
                }
              })}
              type="email"
              autoComplete="email"
              className={errors.email ? 'input-error' : 'input'}
              placeholder="jan@firma.pl"
            />
            {errors.email && (
              <p className="mt-1.5 text-sm text-red-600">{errors.email.message}</p>
            )}
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-semibold text-ink mb-1.5">
              Hasło
            </label>
            <div className="relative">
              <input
                {...register('password', {
                  required: 'Hasło jest wymagane',
                  minLength: {
                    value: 6,
                    message: 'Hasło musi mieć co najmniej 6 znaków'
                  }
                })}
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                className={`${errors.password ? 'input-error' : 'input'} pr-11`}
                placeholder="••••••••"
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 pr-3.5 flex items-center text-ink-faint hover:text-ink"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <EyeOff className="h-5 w-5" />
                ) : (
                  <Eye className="h-5 w-5" />
                )}
              </button>
            </div>
            {errors.password && (
              <p className="mt-1.5 text-sm text-red-600">{errors.password.message}</p>
            )}
          </div>

          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
              />
              <span className="text-sm text-ink-soft">Zapamiętaj mnie</span>
            </label>
            <button type="button" className="text-sm font-medium text-primary-600 hover:text-primary-700">
              Zapomniałeś hasła?
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full py-3 text-base disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? <LoadingSpinner size="sm" /> : 'Zaloguj się'}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-white/35">
          Farm Connect · Omega Operations
        </p>
      </div>
    </div>
  );
};

export default Login;
